<template>
	<div id="myStakeholderDialog">
		<el-tooltip class="item" effect="light" :content="userName" placement="top" id="receiver">
			<el-autocomplete :trigger-on-focus="false" :fetch-suggestions="querySearchAsync" :readonly="inputDis" @select="handleSelect" :style="{width: myWidth}" v-model="userName" placeholder="选择任务干系人" class="input-with-select">
				<el-button slot="append" icon="el-icon-close" @click="reset"></el-button>
				<el-button slot="append" icon="el-icon-plus" :disabled="addBtn" @click="alertDialog"></el-button>
			</el-autocomplete>
		</el-tooltip>
		<el-dialog title="选择任务干系人" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :show-close="true" append-to-body center>
			<el-input placeholder="输入关键字进行过滤" v-model="filterText">
			</el-input>
			<div style="height:400px;" v-loading="loading">
				<el-scrollbar style="height: 100%;">
					<el-tree class="filter-tree" :data="data2" :props="defaultProps" accordion :check-strictly="isStrictly" show-checkbox node-key="ID" :filter-node-method="filterNode" @check-change="checkChange" highlight-current ref="companyTree">
						<span class="custom-tree-node" slot-scope="{ node, data }">
        				<span style="padding-bottom: 0px;">
        					<img v-if="data.ContactType==-2" src="../../assets/img/机构.png" height="20px">
        					<img v-if="data.ContactType==-1" src="../../assets/img/组织.png" height="20px">
        					<img v-if="data.ContactType==0" src="../../assets/img/未知状态.png" height="20px">
        					<img v-if="data.ContactType==1" src="../../assets/img/人员.png" height="20px">
        					<img v-if="data.ContactType==3" src="../../assets/img/计算机.png" height="20px">
        					<img v-if="data.ContactType==2" src="../../assets/img/人员 (女).png" height="20px">
        					<img v-if="data.ContactType==4" src="../../assets/img/分类.png" height="20px">
        					{{ node.label }}
        				</span>
						</span>
					</el-tree>
				</el-scrollbar>
			</div>
			<div style="text-align: center;">
				<el-button @click="toClose">清空</el-button>
				<el-button type="primary" @click="toSure">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { GetAllContactTaskStakeholder, toTree } from '@/api/modules/basicData/personnel'
	import { listToTree } from '@/api/modules/basicData/commonData'
	export default {
		name: 'selectStakeholder',
		data() {
			return {
				userName: '',
				dialogVisible: false,
				filterText: '',
				data2: [],
				dataList: [],
				addBtn: false,
				inputDis: false,
				editCheckId: '',
				loading: false,
				myWidth: '',
				isStrictly: false,
				editCheckIdArr: [],
				selectedData: [],
				selectedUser: [],
				defaultProps: {
					id: 'ID',
					children: 'children',
					label: 'Name'
				},
				data: []
			};
		},
		props: {
			isRadio: Boolean,
			setWidth: {
				type: String,
				default: '250px'
			},
			userId: {
				type: String,
				default: ''
			},
			isValidateMethod: {
				type: Boolean,
				default: false
			},
			idArray: {
				type: Array,
				default: function() {
					return []
				}
			},
		},
		mounted() {},
		watch: {
			filterText(val) {
				this.debouncedSearch(val)
			},
			userName(val, oldVal) {
				if(val == '') {
					this.addBtn = false
				} else {
					this.addBtn = false
				}
			},
			'idArray': {
				handler(val, oldVal) {
					if(val.length > 0) {
						if(this.dataList.length == 0) {
							GetAllContactTaskStakeholder(this.userId, '', 0).then(res => {
								res.forEach((c) => {
									for(var i = 0; i <= this.idArray.length; i++) {
										if(c.ID == this.idArray[i]) {
											this.selectedUser.push(c)
										}
									}
								})
								this.assignmentInput()
							}).catch(res => {
								console.log('异常原因：' + res);
							})
						} else {
							this.dataList.forEach((c) => {
								for(var i = 0; i <= this.idArray.length; i++) {
									if(c.ContactType == this.idArray[i]) {
										this.selectedUser.push(c)
									}
								}
							})
							this.assignmentInput()
						}
					}
				},
				deep: true //深度监听
			}
		},
		created() {
			var _ = require('lodash');
			this.debouncedSearch = _.debounce(this.searchTree, 1000)
			this.checkSource()
			this.setOption()
		},
		methods: {
			reset() {
				this.addBtn = false
				this.inputDis = false
				this.userName = ''
				this.selectedData = []
				this.selectedUser = []
				this.$emit('Clear');
			},
			querySearchAsync(queryString, cb) {
				GetAllContactTaskStakeholder(this.userId, queryString, 1).then(res => {
						var result = []
						res.forEach((c) => {
							if(c.ContactType == 0 || c.ContactType == 1 || c.c.ContactType == 2|| c.ContactType == 3) {
								c.value = c.Name
								result.push(c)
							}
						})
						cb(result);
					})
					.catch(res => {
						console.log('异常原因：' + res);
					})
			},
			handleSelect(item) {
				//1.赋值
				this.addBtn = false
				this.inputDis = true
				this.selectedUser.push(item)
			},
			searchTree(val) {
				this.getTreeData(val)
			},
			setOption() {
				if(this.setWidth != '') {
					this.myWidth = this.setWidth
				}
			},
			checkSource() {
				if(this.isRadio == true) {
					this.isStrictly = true
				}
			},
			//实现单双选以及过滤非人员
			checkChange(item, node, self) {
				if(this.isRadio == true) {
					if(node == true) { //点击未选中复选框
						if(c.ContactType == 0 || item.ContactType == 1 || item.ContactType == 2|| item.ContactType == 3) {
							this.editCheckId = item.ID;
							this.$refs.companyTree.setCheckedKeys([item.ID]);
						} else {
							if(this.editCheckId != '') {
								this.$refs.companyTree.setCheckedKeys([this.editCheckId]);
							} else {
								this.$refs.companyTree.setCheckedKeys([]);
							}
						}
					}
				}
			},
			alertDialog() {
				if(this.data2.length == 0) {
					this.getTreeData('')
				}
				this.dialogVisible = true
			},
			handleClose(done) {
				this.filterText = ''
				this.editCheckId = ''
				this.$refs.companyTree.setCheckedKeys([]);
				done();
			},
			open(title, message) {
				this.$alert(message, title, {
					confirmButtonText: '确定'
				});
			},
			filterNode(value, data) {
				if(!value) return true;
				return data.Name.indexOf(value) !== -1;
			},
			getTreeData(keyword) {
				this.loading = true
				GetAllContactTaskStakeholder(this.userId, keyword, 0).then(response => {
					this.dataList = response
					console.time("shijian")
					this.data2 = listToTree('ID', 'ParentID', this.dataList)
					//this.data2 = this.toTree(this.dataList, 'ID', 'ParentID', 0)
					console.timeEnd("shijian")
					this.loading = false
				})
			},
			toSure() {
				this.userName = ''
				this.selectedData = this.$refs.companyTree.getCheckedNodes()
				if(this.selectedUser.length > 0) {
					var arr = this.filter(this.selectedData, this.selectedUser)
					arr.forEach((c) => {
						this.selectedUser.push(c)
					})
				} else {
					this.selectedData.forEach((c) => {
						if(c.ContactType == 0 || c.ContactType == 1 || c.ContactType == 2|| c.ContactType == 3) {
							this.selectedUser.push(c)
						}
					})
				}
				if(this.selectedUser.length > 0) {
					this.inputDis = true
				}
				let isValidate = true; //验证是否通过
				if(this.isValidateMethod == true) {
					this.$emit("toValidate", this.selectedUser, function(str) {
						isValidate = str;
					});
					if(isValidate) {
						this.assignmentInput()
						this.toClose()
						this.dialogVisible = false
					}
				} else {
					this.$emit("getValue", this.selectedUser)
					this.assignmentInput()
					this.toClose()
					this.dialogVisible = false
				}
			},
			assignmentInput() { //input框赋值
				this.selectedUser.forEach((c) => {
					this.userName += c.Name + ','
				})
				this.userName = this.userName.substring(0, this.userName.lastIndexOf(','));
			},
			toClose() { //关闭弹窗
				this.filterText = ''
				this.editCheckId = ''
				this.$refs.companyTree.setCheckedKeys([]);
			},
			filter(arr1, arr2) { /*arr1 传被检测对象，arr2传已存在的列表*/
				var arrRet = []
				for(var j = 0; j < arr1.length; j++) {
					var b = false
					for(var i = 0; i < arr2.length; i++) {
						if(arr1[j].ContactType != 0 && arr1[j].ContactType != 1 && arr1[j].ContactType != 2&& arr1[j].ContactType != 3) {
							b = true;
							break;
						}
						if(arr1[j].ID == arr2[i].ID) {
							b = true;
							break;
						}
					}
					if(!b) {
						arrRet.push(arr1[j]);
					}
				}
				return arrRet;
			}
		},
		computed: {}
	}
</script>

<style scoped>
	.el-scrollbar__wrap {
		overflow-x: hidden;
	}
	
	#receiver .el-button {
		padding: 12px 10px;
	}
	
	#myStakeholderDialog .el-tree-node__label {
		font-size: 16px;
	}
	
	#myStakeholderDialog .custom-tree-node {
		box-sizing: border-box;
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 16px;
		height: 30px;
		line-height: 30px;
		padding-right: 8px;
	}
	
	#myStakeholderDialog .custom-tree-node img {
		vertical-align: top;
		margin-top: 4px;
	}
	/*.el-autocomplete-suggestion .el-popper{
		width: 390px;
	}*/
	
	.el-autocomplete-suggestion {
		width: 300px !important;
	}
</style>